export function pricify(text){
    let count=1;
    let result = text.split("").reverse().map((i)=>{
        if(count>=3){
            count=1;
            return(","+i);
        }else{
            count++;
            return i;
        }
    });
    result=result.reverse().join("");
    return(result);
}